import React from 'react';
import './AssignmentCalendar.scss';
import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt,
    faCalendarDay,
    faCalendarWeek,
} from '@fortawesome/free-solid-svg-icons';
import CommonContext from '../Common';
import { views } from './CalendarViews';
import AddDailyTimesheetButton from './AddDailyTimesheetButton';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';

export const AssignmentToolbarNavigation = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE',
    ADD: 'ADD',
};

export class AssignmentToolbar extends React.Component {
    static contextType = CommonContext;

    render() {
        if (!(this.context ?? {}).user) {
            return null;
        }

        const { onNavigate, onView, date } = this.props;

        const label = moment(date).format(MomentDateFormat.MonthAndYear);

        return (
            <ButtonToolbar className="mb-2 d-flex flex-row">
                <ButtonGroup size="sm">
                    <Button
                        color="outline-primary p-1"
                        onClick={() =>
                            onNavigate(AssignmentToolbarNavigation.PREVIOUS)
                        }
                    >
                        <i className="fa fa-step-backward" />
                    </Button>
                    <Button
                        color="outline-primary p-1"
                        onClick={() =>
                            onNavigate(AssignmentToolbarNavigation.TODAY)
                        }
                    >
                        <small>TODAY</small>
                    </Button>
                    <Button
                        color="outline-primary p-1"
                        onClick={() =>
                            onNavigate(AssignmentToolbarNavigation.NEXT)
                        }
                    >
                        <i className="fa fa-step-forward" />
                    </Button>
                </ButtonGroup>
                <div className="rbc-toolbar-label d-flex flex-column flex-fill align-items-center justify-content-center">
                    <strong>{label}</strong>
                    <small>{this.context.user.fullName}</small>
                </div>

                <AddDailyTimesheetButton {...this.props} />

                <ButtonGroup size="sm">
                    {views.map((view) => (
                        <Button
                            color="outline-primary text-capitalize"
                            key={view}
                            onClick={() => onView(view)}
                        >
                            <FontAwesomeIcon
                                className="text-muted"
                                icon={
                                    view === 'month'
                                        ? faCalendarAlt
                                        : view === 'day'
                                          ? faCalendarDay
                                          : faCalendarWeek
                                }
                                size="lg"
                            />
                        </Button>
                    ))}
                </ButtonGroup>
            </ButtonToolbar>
        );
    }
}
